import React from "react";
import ProgressBar from "react-bootstrap/ProgressBar";

export const ProgressLine = () => {
  return <ProgressBar now={60} />;
};
